import { Color } from "@clovis/server/src/app/config/colors/colors";
import type { FC } from "react";
import * as React from "react";
import { useNetwork } from "~/config/capacitor/network/hook";
import { Badge } from "~/design-system/Badge";

export const OfflineComponent: FC = () => {
  const { isOffline } = useNetwork();

  if (!isOffline) {
    return null;
  }

  return <Badge color={Color.Orange}>You are using Clovis offline</Badge>;
};
